import gql from 'graphql-tag';
import FragmentAuditLog from 'graphql/fragments/audit-log';

export default gql`
  query listAuditLogs($startTime: AWSDate!, $endTime: AWSDate!, $limit: Int) {
    listAuditLogs(
      filter: { startTime: $startTime, endTime: $endTime, limit: $limit }
    ) {
      items {
        ...FragmentAuditLog
      }
    }
  }

  ${FragmentAuditLog}
`;
